import {apiRequest} from "../../service/service";

class Api {
    getBranches = (params = {}) => {
        const url = `network`;
        const config = {
            method:'get',
            url:url,
            params
        };
        return apiRequest(config);
    };
}

export default Api;
